/**
 *
 * HeroSection
 *
 */

import React from 'react';
import {
  STitle,
  SSlug,
  SSubTitle,
  SSection,
  SActions,
  SContainer,
  SImage,
} from './styles';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

const HeroSection = ({
  slug,
  mainTitle,
  subTitle,
  children,
  $backgroundColor,
  actions,
  backgroundImage,
  type,
  highLightMode,
  imageData = null,
  useGracefulImage = false,
}) => {
  return (
    <SSection
      name="Hero Section"
      $backgroundColor={$backgroundColor}
      // backgroundImage={backgroundImage || defaultBGImage}
      type={type}
    >
      <SImage
        alt=""
        filename={backgroundImage || 'images/main_seo_image.jpg'}
        imageData={imageData}
        useDeprecatedImage={!useGracefulImage}
      />
      <SContainer fluid>
        <Row className={'align-items-center justify-content-center mb-5'}>
          {slug && (
            <Col sm={12} className={'text-center'}>
              <SSlug colorVariant={highLightMode}>{slug}</SSlug>
            </Col>
          )}
          {mainTitle && (
            <Col sm={12}>
              <STitle highLightMode={highLightMode}>{mainTitle}</STitle>
            </Col>
          )}
          {subTitle && (
            <Col sm={12} lg={type === `small` ? 5 : 12}>
              <SSubTitle highLightMode={highLightMode}>{subTitle}</SSubTitle>
            </Col>
          )}
          {actions && (
            <Col sm={12}>
              <SActions>{actions}</SActions>
            </Col>
          )}
          {children && <Col sm={12}>{children}</Col>}
        </Row>
      </SContainer>
    </SSection>
  );
};

HeroSection.propTypes = {
  mainTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  slug: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  backgroundImage: PropTypes.string,
  type: PropTypes.string,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  actions: PropTypes.node,
  $backgroundColor: PropTypes.string,
  highLightMode: PropTypes.string,
  useGracefulImage: PropTypes.bool,
  imageData: PropTypes.object,
};

export default HeroSection;
